export type TagColor =
  'slate' | 'amber' | 'emerald' | 'rose' | 'blue' | 'violet';

export type TagToggleGroupTag = { id: string; name: string; color: string };

export type TagToggleGroupProps = {
  tags: TagToggleGroupTag[];
  modelValue: string[];
  label: string;
  disabled?: boolean;
};

const TAG_PILL_CLASSES: Record<TagColor, { light: string; dark: string }> = {
  slate: {
    light: 'bg-slate-100 text-slate-700',
    dark: 'bg-slate-700 text-white',
  },
  amber: {
    light: 'bg-amber-100 text-amber-800',
    dark: 'bg-amber-600 text-white',
  },
  emerald: {
    light: 'bg-emerald-100 text-emerald-800',
    dark: 'bg-emerald-600 text-white',
  },
  rose: { light: 'bg-rose-100 text-rose-800', dark: 'bg-rose-600 text-white' },
  blue: { light: 'bg-blue-100 text-blue-800', dark: 'bg-blue-600 text-white' },
  violet: {
    light: 'bg-violet-100 text-violet-800',
    dark: 'bg-violet-600 text-white',
  },
};

export const getTagPillClass = (color: string, selected: boolean): string => {
  const palette =
    Object.entries(TAG_PILL_CLASSES).find(([key]) => key === color)?.[1] ??
    TAG_PILL_CLASSES.slate;
  return selected ? palette.dark : palette.light;
};
